export enum MisLinkActionTypes {
    API_RESPONSE_SUCCESS = '@@misLink/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@misLink/API_RESPONSE_ERROR',
    MIS_LINK_LIST = '@@misLink/MIS_LINK_LIST',
    ADD_MIS_LINK = '@@misLink/ADD_MIS_LINK',
    SHOW_MIS_LINK = '@@misLink/SHOW_MIS_LINK',
    UPDATE_MIS_LINK = '@@misLink/UPDATE_MIS_LINK',
    DELETE_MIS_LINK = '@@misLink/DELETE_MIS_LINK',
}